import debounce from 'lodash.debounce';
import BaseFilter from '../modules/filters/baseFilter';
import { MarkerClusterer } from "@googlemaps/markerclusterer";


$ = jQuery;

class LocationsMap {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;
        this.root = el;
        this.map = this.root.querySelector('[data-locations-map-map]');
        this.mapId = this.map ? this.map.getAttribute('data-map-id') : "83fd182ae16cb0d9";
        this.switcher = this.root.querySelector('[data-filter-switcher]');
        this.contactsWrapper = this.root.querySelector(
            '[data-locations-map-contacts]'
        );
        this.locationBoxesWrapper = this.root.querySelector(
            '.locations-map__boxes-wrapper'
        );
        this.baseCategory = this.root.querySelector(
            '[data-locations-map-main-cat]'
        );
        this.googleMapInstance = null;
        this.pin = null;
        this.cluster = null;
        this.markers = [];
        this.infoWindows = [];
        this.locationTypesArr = [];
        this.activeRegion = null;
        this.activeCity = null;
        this.activeVoid = null;
        this.ogIconUrl = '/app/themes/main/dist/img/gmaps/unactive-pin.png';
        this.darkIconUrl = '/app/themes/main/dist/img/gmaps/active-pin.png';
        this.isPopUp = this.map.getAttribute('data-is-popup') || false;
        this.select2City = this.root.querySelector("[name='location-city']");
        this.select2Void = this.root.querySelector("[name='location-void']");
        this.loader = this.root.querySelector('.locations-map__loader');

        this.coords = JSON.parse(
            this.map.getAttribute('data-locations-coords')
        );
        this.locationTypes = this.root.querySelectorAll(
            '[data-locations-map-type]'
        );
        this.getLocations = debounce(this.loadLocations, 100);

        return true;
    }

    init() {
        this.initGoogleMap();
        this.setMarkers();
        this.initSwitcher();
        this.setTypesCheckboxes();

        if (this.select2City) this.handleCitySelect();
        if (this.select2Void) this.handleVoidSelect();
    }

    handleCitySelect() {
        const citySelect = this.select2City;
        const citySwitch = this.onCitySwitch.bind(this);
        $(this.select2City).on('select2:select', function (e) {
            citySelect.classList.add('selected');
            citySwitch(e);
        });

        const firstOption = this.select2City.options[1].value;
        if (firstOption) $(this.select2City).val(firstOption).trigger('select2:select');
    }

    handleVoidSelect() {
        const voidSelect = this.select2Void;
        const voidSwitch = this.onVoidSwitch.bind(this);
        $(this.select2Void).on('select2:select', function (e) {
            voidSelect.classList.add('selected');
            voidSwitch(e);
        });

        const firstOption = this.select2Void.options[1].value;
        if (firstOption) $(this.select2Void).val(firstOption).trigger('select2:select');
    }

    initSwitcher() {
        if (!this.switcher) return;
        new BaseFilter(this.switcher, this.root);

        this.regionsSwitch = this.onRegionsSwitch.bind(this);
        this.root.addEventListener('filter-switcher-change', event =>
            this.regionsSwitch(event)
        );
    }

    async initGoogleMap() {
        if (!this.map) return;
        const position = {lat: 52.423956, lng: 18.4661922};
        const { Map } = await google.maps.importLibrary("maps");

        this.googleMapInstance = new Map(this.map, {
            zoom: 7,
            center: position,
            mapId: this.mapId || "83fd182ae16cb0d9",
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            clickableIcons: false
        });

        google.maps.event.addListener(this.googleMapInstance, 'click', this.clearInfoWindows.bind(this));
            
    }

    clearInfoWindows() {
        if(!this.infoWindows || this.infoWindows.length === 0) return;

        this.infoWindows.forEach(infoWindow => {
            infoWindow.close();
        });

        this.markers.forEach(marker => {
            const markerContent = marker.content;
            if (!markerContent.src.includes(this.ogIconUrl)) {
                marker.content = this.createIcon();
            }
        })
    }

    async setMarkers() {
        if (!this.coords) return;
        const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
        if (!this.googleMapInstance) return;
        this.clearGoogleAssets();
        
        if (this.coords.length > 0) {
            this.coords.forEach(item => {
                const {
                    coords,
                    name,
                    address,
                    location_postal_city,
                    location_city,
                    phone,
                    email,
                } = item;
                let { lat, lon } = coords;
    
                if (lat !== '' && lon !== '') {
                    lat = parseFloat(lat);
                    lon = parseFloat(lon);

                    let htmlContent = '';

                    if (name && name.length > 0) {
                        htmlContent += `<h5 class="under-h5">${name}</h5>`;
                    }
                    if (address && address.length > 0) {
                        let addressClean = address.split(",").join("");
                        htmlContent += `<p class="locations-map__tooltip-address">${addressClean}</p>`;
                    }
                    if (
                        location_postal_city &&
                        location_postal_city.length > 0
                    ) {
                        htmlContent += `<p>${location_postal_city} ${
                            location_city ? location_city : ''
                        }</p>`;
                    }
                    if (phone && phone.length > 0) {
                        htmlContent += `<a class="locations-map__tooltip-anchor" href="tel:${phone}"><i class="icon icon-phone-outline d-flex"></i>${phone}</a>`;
                    }
                    if (email && email.length > 0) {
                        htmlContent += `<a class="locations-map__tooltip-anchor" href="tel:${email}"><i class="icon icon-email-outline d-flex"></i>${email}</a>`
                    }

                    const marker = new AdvancedMarkerElement({
                        position: {lat: lat, lng: lon},
                        map: this.googleMapInstance,
                        content: this.createIcon(),
                    });
                    
                    const infowindow = new google.maps.InfoWindow({
                        shouldFocus: false,
                        content: htmlContent,
                        ariaLabel: name,
                    });

                    this.infoWindows.push(infowindow);

                    marker.addListener("click", e => {
                        this.markers.forEach(item => item.content = this.createIcon());
                        this.infoWindows.forEach(item => item.close());

                        setTimeout(() => {
                            marker.content = this.createIcon("dark");
                            infowindow.open({
                                anchor: marker,
                                map: this.googleMapInstance
                            })
                        }, 200);
                    })
    
                    this.markers.push(marker);
                }
            });
            this.setGoogleCluster();
        }
    }

    setGoogleCluster() {
        this.cluster = new MarkerClusterer({markers: this.markers, map: this.googleMapInstance});
    }

    clearGoogleAssets() {
        if (!this.markers || this.markers.length === 0) return;
        if (this.cluster) this.cluster.setMap(null);
        for (let i = 0; i < this.markers.length; i++) {
            this.markers[i].setMap(null);
        }
        this.markers = [];
        this.infoWindows = [];
        this.cluster = new MarkerClusterer({markers: this.markers, map: this.googleMapInstance});
    }

    createIcon(variant = "og") {
        const icon = document.createElement("img");
        icon.width = 28;
        if (variant === "dark") {
            icon.src = this.darkIconUrl;
        } else {
            icon.src = this.ogIconUrl;
        }

        return icon;
    }

    loadLocations() {
        const formData = new FormData();
        formData.append('action', 'get_locations_ajax');
        this.locationTypesArr = [];
        this.locationTypes.forEach(type => {
            const { checked, value } = type;
            if (checked) this.locationTypesArr.push(value);
        });

        if (this.activeCity !== null) formData.append('city', this.activeCity);
        if (this.activeRegion !== null) formData.append('region', this.activeRegion);
        if (this.activeVoid !== null) formData.append('void', this.activeVoid);
        if (this.baseCategory) {
            const { value } = this.baseCategory;
            if (value !== '') this.locationTypesArr.push(value);
        }

        formData.append('types', this.locationTypesArr);

        if (this.locationTypesArr.length > 0 && !this.activeCity)  this.activeCity = -1;
        if (this.locationTypesArr.length === 0 && this.activeCity === -1) this.activeCity = null;

        if (this.locationTypesArr.length > 0 && !this.activeVoid) this.activeVoid = -1;
        if (this.locationTypesArr.length === 0 && this.activeVoid === -1) this.activeVoid = null;
        
        $.ajax({
            type: 'POST',
            url: ajax.url,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            data: formData,
            success: function (response) {
                const data = JSON.parse(response);
                const { locations, contacts_html, location_boxes_html } = data;

                if (this.contactsWrapper)
                    this.contactsWrapper.innerHTML = contacts_html;

                if (this.locationBoxesWrapper) {
                    this.locationBoxesWrapper.innerHTML = location_boxes_html;
                }
                this.coords = locations;
                this.setMarkers();
            }.bind(this),
            error: function () {}.bind(this),
            complete: function () {
                this.loader.classList.add('d-none');
            }.bind(this),
        });
    }

    setTypesCheckboxes() {
        if (!this.locationTypes) return;

        this.onLocationType = this.onTypeClick.bind(this);
        this.locationTypes.forEach(type => {
            type.addEventListener('change', event =>
                this.onLocationType(event)
            );
        });
    }

    onTypeClick(event) {
        const { currentTarget } = event;
        this.loader.classList.remove('d-none');
        this.getLocations();
    }

    onCitySwitch(event) {
        const { target } = event;
        this.activeCity = target.value;

        this.loader.classList.remove('d-none');
        this.getLocations();
    }

    onVoidSwitch(event) {
        const { target } = event;
        this.activeVoid = target.value;

        this.loader.classList.remove('d-none');
        this.getLocations();
    }

    onRegionsSwitch(event) {
        const { detail } = event;
        const { value } = detail;
        this.activeRegion = value;

        this.loader.classList.remove('d-none');
        this.getLocations();
    }
}

const maps = document.querySelectorAll('[data-locations-map]');
const initMaps = maps => {
    if (!maps) return;

    maps.forEach(el => {
        new LocationsMap(el);
    });
};

initMaps(maps);
